export default "__VITE_ASSET__c357eda9__"